export const CnasAgency = {
    path: '/cnas_agencies',
    name: 'cnas_agencies',
    component: () => import('@/views/CnasAgency/CnasAgencyPage.vue'),
    children: [
        {
            path: '/cnas_agencies/add',
            name: 'cnas_agencies.add',
            component: () => import('@/views/CnasAgency/Form/CnasAgencyForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/cnas_agencies/edit/:id',
            name: 'cnas_agencies.edit',
            component: () => import('@/views/CnasAgency/Form/CnasAgencyForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/cnas_agencies/view/:id',
            name: 'cnas_agencies.view',
            component: () => import('@/views/CnasAgency/Form/CnasAgencyForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/cnas_agencies/delete/:id',
            name: 'cnas_agencies.delete',
            component: () => import('@/views/CnasAgency/Form/CnasAgencyForm.vue'),
            props: {deleteAction: true}
        },
    ],
}